import { useQuery } from '@apollo/client/react';
import { TrainingPlanFilterOptionsDocument } from '../../../graphql/types';
import { AttributeLabels } from './util';

export const useTrainingPlanAttributeLabels = (): AttributeLabels => {
  const { data } = useQuery(TrainingPlanFilterOptionsDocument);

  return {
    difficulties: Object.fromEntries(
      (data?.trainingPlanDifficulties ?? []).map(({ value, name }) => [
        value,
        name,
      ]),
    ),
    durations: Object.fromEntries(
      (data?.trainingPlanDurations ?? []).map(({ value, name }) => [
        value,
        name,
      ]),
    ),
    equipmentCategories: new Map(
      (data?.trainingPlanEquipmentCategories ?? []).map(({ value, name }) => [
        value,
        name,
      ]),
    ),
    frequencies: Object.fromEntries(
      (data?.trainingPlanFrequencies ?? []).map(({ value, name }) => [
        value,
        name,
      ]),
    ),
    phases: Object.fromEntries(
      (data?.trainingPlanPhases ?? []).map(({ value, name }) => [value, name]),
    ),
  };
};
